import { useAtom } from 'jotai';
import Lottie from 'lottie-react';
import React, { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { greenCheckLottie } from '../assets/lottie';
import { P2L_EMBEDDED_VIDEO } from '../constants';
import { Language } from '../enum';
import { userAtom } from '../jotai-atoms/user.atom';
import { Modal, ModalProps } from './Modal';

export interface ModalReservationBookedProps {
  show: boolean;
  onClose: () => void;
  isGameClass: boolean;
}

export const ModalReservationBooked: FC<ModalReservationBookedProps> = ({
  show,
  onClose,
  isGameClass,
}) => {
  const __ = useTranslation().t;
  const [user] = useAtom(userAtom);

  const lang = (user?.lang || 'en') as Language;
  const p2lVideoUrl = P2L_EMBEDDED_VIDEO[lang];
  const modalTitle = isGameClass ? __('classBookedMessage') : __('successfulBooking');
  const headingText = !isGameClass ? __('classBookedMessage') : null;
  const isP2LEmbeddedEnabled = isMobile
    ? user?.context?.p2lEmbeddedZoomPlayerMobileEnabled
    : user?.context?.p2lEmbeddedZoomPlayerEnabled;

  const modalProps: ModalProps = {
    show,
    onClose,
    type: 'default',
    title: modalTitle,
    submitButtonText: __('continue'),
  };

  const Heading = () => {
    if (!headingText) {
      return null;
    }
    return <StyledHeading>{headingText}</StyledHeading>;
  };

  return (
    <StyledModal {...modalProps} onSubmit={onClose}>
      <ImageContainer>
        <Lottie animationData={greenCheckLottie} />
      </ImageContainer>
      <Heading />
      <StyledP>
        {!isGameClass ? (
          __('confirmAttendanceBeforeClassPreClassActivities')
        ) : (
          <>
            {isP2LEmbeddedEnabled ? (
              <Trans
                alt={__('confirmAttendanceBeforeClassWatchVideoNewInPlay2Learn')}
                i18nKey="confirmAttendanceBeforeClassWatchVideoNewInPlay2Learn"
              >
                Remember that, 5 minutes before the class you, must confirm your attendance. Watch
                this video to find out what's new in{' '}
                <strong>
                  <a href={p2lVideoUrl} target="_blank">
                    Play2Learn
                  </a>
                </strong>
                !
              </Trans>
            ) : (
              __('confirmAttendanceBeforeClassLaptopOrDesktopZoomApp')
            )}
          </>
        )}
      </StyledP>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  max-width: 560px;
`;

const StyledHeading = styled.p`
  font-family: 'Inter';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 12px !important;
`;

const StyledP = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 8px !important;
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 225px;
`;
